import { clone } from '@jack-henry/frontend-utils/functions';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';
import { EdiAddenda } from './edi-report-columns';

interface EdiReportItemDto {
    ediDate: string;
    ediAddenda: EdiAddenda[];
    ediAmount: number;
}
const nullEdiReportItem: EdiReportItemDto = {
    ediDate: '',
    ediAddenda: [{ item1: '', item2: '' }],
    ediAmount: 0,
};

export class EdiReportItemVm {
    constructor(private dto = clone(nullEdiReportItem)) {}

    public createDefault() {
        return new EdiReportItemVm(this.dto);
    }

    public get ediDate() {
        return format(this.dto.ediDate, 'P');
    }

    public get ediAmount() {
        return formatUsdCurrency(this.dto.ediAmount);
    }

    public get ediAddenda() {
        return this.dto.ediAddenda;
    }
}
